import { ButtonHTMLAttributes, FC } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  loading?: boolean;
}

const STYLES = {
  primary: 'bg-lend-blue text-white hover:bg-lend-blue-dark disabled:bg-lend-blue/50',
  secondary: 'bg-white text-lend-ink border border-gray-300 hover:bg-gray-50 disabled:opacity-60',
  danger: 'bg-lend-red text-white hover:bg-lend-red/90 disabled:bg-lend-red/50',
};

const Button: FC<Props> = ({ variant = 'primary', loading = false, disabled, className = '', children, ...props }) => (
  <button
    type="button"
    {...props}
    disabled={disabled || loading}
    className={`w-full h-12 md:h-14 rounded-md text-base font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-lend-blue focus-visible:ring-offset-2 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2 ${STYLES[variant]} ${className}`}
  >
    {loading ? <span className="h-5 w-5 rounded-full border-2 border-current border-r-transparent animate-spin" aria-hidden /> : children}
  </button>
);

export default Button;
